import React from 'react';
import ViewList from './view-list'
const CalendarView = ({items,readOnly,history}) => {
    return (
        <>
            <ViewList items={items} readOnly={readOnly} history={history} />
        </>
    );
};

export default CalendarView;